/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable react/jsx-indent */
import React from 'react';
import { timeFormat } from '../../../../../../libs/HelperContent';
import MeetingCountdown from './MeetingCountdown';

const TWDescription = (props:any) =>
{
	const { joinDetails } = props;

	return (

		<div className='flexCol pdngSM'>
			<div className='flexRow pdngBMD'>
				<span className='mainHdngTxt'>{joinDetails?.title || ''}</span>
			</div>
			{joinDetails?.description &&
					<div className='flexRow pdngBMD'>
						<span className='subHeadingXS'>{ joinDetails?.description || '' }.</span>
					</div>}
			<div className='flexRow'>
				<span className='titleHeading subHeadingXS'>
					{new Intl.DateTimeFormat('en-In',
						{ day: 'numeric', month: 'short', year: 'numeric' })
						.format(joinDetails?.startTime)} ,
					{ timeFormat(joinDetails?.startTime)} to {timeFormat(joinDetails?.startTime + joinDetails?.duration)}
				</span>
			</div>
			<div className='resColRowMobOnly'>
				<MeetingCountdown joinDetails={joinDetails}/>
				{/* <div className='flexMinWidthRow'>
						<span className='titleHeading subHeadingXS'>10:30 AM to 11:30 AM</span>
					</div> */}
			</div>
		</div>
	);
};

export default TWDescription;